import { Injectable } from "@angular/core";
import { CanLoad, Route, Router, UrlSegment } from "@angular/router";
import { ACL } from "app/shared/models/acl";
import { Observable } from "rxjs";
import { AuthService } from "../services/admin/auth/auth.service";

/**
 * This guard is used to control the access to the pim module
 */
@Injectable()
export class PimModuleGuard implements CanLoad {
    constructor(private _authService: AuthService, private _router: Router) {}

    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        const acl: ACL = this._authService.getUserAclFromToken();

        let result;
        if (acl.SYSPAD_PIM_ELEMENTTYPE_LIST === 1 || acl.SYSPAD_PIM_ELEMENT_LIST === 1 || acl.SYSPAD_PIM_FIELDSET_LIST === 1 || acl.SYSPAD_PIM_LIST_LIST === 1 || acl.SYSPAD_PIM_TAG_LIST === 1) {
            result = true;
        } else {
            result = this._router.parseUrl("/");
        }

        return result;
    }
}
